import animate from "@/assets/animate"

export default {
    data() {
        return {
            animate: animate,
        }
    },
    mounted() {
        this.scrollFun();
        window.addEventListener("scroll", this.scrollFun);
    },
    methods: {
        scrollFun() {
            this.animate(document.getElementsByClassName("content")[0], "fadeInUp");
            document.getElementsByClassName("title").forEach(item => {
                this.animate(item, "fadeInUp");
            });
            document.getElementsByClassName("littleTitle").forEach(item => {
                this.animate(item, "fadeInUp");
            });
            document.getElementsByClassName("type").forEach(item => {
                this.animate(item, "fadeInUp");
            });
            document.getElementsByClassName("typeIntro").forEach(item => {
                this.animate(item, "fadeInUp");
            });
            document.getElementsByClassName("advantage").forEach(item => {
                this.animate(item, "fadeInUp");
            });
            document.querySelectorAll("img").forEach((item, index) => {
                if (index !== 2) {
                    this.animate(item, "fadeInUp");
                }
            });
            this.animate(document.getElementsByClassName("bannerImg")[0], "smallFadeInUp");
        },
        handleNavToGov() {
            window.open("https://beian.miit.gov.cn/#/Integrated/index");
        }
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.scrollFun);
    }
}
